import { connect } from 'react-redux';

import { addComment } from './actions';
import Comments from './Comments';

export default connect(({ discussion: { comments } }) => ({ comments }), {
  onAddComment: addComment,
})(Comments);
